import { render } from "./uploadSubmitted.vue?vue&type=template&id=bc7c6aea&scoped=true"
import script from "./uploadSubmitted.vue?vue&type=script&lang=js"
export * from "./uploadSubmitted.vue?vue&type=script&lang=js"

import "./uploadSubmitted.vue?vue&type=style&index=0&id=bc7c6aea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc7c6aea"]])

export default __exports__